import WidgetBase from '../widget.base';
import { each } from 'App/lib/util';
import featSniffer from 'App/lib/featureDetection';
import { mq } from '../../lib/util';
export default class CardCarousel extends WidgetBase {
    static selector = '[data-usc-cc]';
    threshold = 100;
    isMobile = false;
    isTablet = false;

    constructor(el) {
        super(el);

        this.index = 0;
        this.$el = $(el);
        this.$cards = this.$el.find('[data-cc-card]');
        this.$carousel = this.$el.find('[data-carousel]');
        this.$next = this.$el.find('[data-js-next]');
        this.$prev = this.$el.find('[data-js-prev]');

        this.$next.on('click', this.next.bind(this));
        this.$prev.on('click', this.prev.bind(this));

        this.initializeCarousel();
        const supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
        if(!supportsTouch){
            this.$carousel.parent().css('overflow', 'hidden');
        }
        setTimeout(() => {
            this.loaded();
        });
    }

    goToIndex(index){
        const width = Math.floor(this.$cards.eq(0).outerWidth());
        const targetIndex = this.isMobile || this.isTablet ? index : index - 1;
        const translate = width * (targetIndex) * -1;
        this.$carousel.css({'transform': 'translate3d('+translate+'px, 0px, 0px)'});
    }

    next(){
        if(this.isMobile){
            if(this.index+1 > this.$cards.length - 1){
                return;
            }
            if(this.index+1 >= this.$cards.length - 1){
                this.$next.addClass('inactive');
            }
        }else {
            if(this.index+1 > this.$cards.length - 2){
                return;
            }
            if(this.index+1 >= this.$cards.length - 2){
                this.$next.addClass('inactive');
            }
        }

        this.$prev.removeClass('inactive');
        this.index+=1;
        this.goToIndex(this.index);
    }

    prev(){
        if(this.isMobile || this.isTablet){
            if(this.index <= 0){
                return;
            }
            if(this.index <= 1){
                this.$prev.addClass('inactive');
            }
        } else {
            if(this.index-1 <= 0){
                return;
            }
            if(this.index-1 <= 1){
                this.$prev.addClass('inactive');
            }
        }
        this.$next.removeClass('inactive');
        this.index-= 1;
        this.goToIndex(this.index);
    }

    initializeCarousel(){
        this.$prev.addClass('inactive');
        let isDesktop = mq('md');
        let isTablet = mq('sm', 'md');

        if(isDesktop){
            this.index = 1;
        }
        else if(isTablet){
            this.index = 0;
            this.isTablet = true;
        }
        else {
            this.index = 0;
            this.isMobile = true;
        }

        if (featSniffer.touch()) {
            this.addTouchEvents();
        }
    }

    addTouchEvents(){
        let isTouchStart = false;

        // initial mouse X for `mousedown`
        let touchX;
        let touchY;

        // element transform style before/after
        let transformX;

        // element X before and after move
        let elementX = 0;

        this.$carousel.on('touchstart', onTouchStart.bind(this));
        this.$carousel.on('touchmove', onTouchMove.bind(this));
        this.$carousel.on('touchend', onTouchEnd.bind(this));

        function onTouchStart(event){
            touchX = event.touches[0].clientX;
            touchY = event.touches[0].clientY;
            transformX = parseTransformX(this.$carousel);
            this.$carousel.addClass('dragging');
        }

        function onTouchMove(event){
            let deltaX = event.touches[0].clientX - touchX;
            let deltaY = event.touches[0].clientY - touchY;

            const absDeltaX = Math.abs(deltaX);
            const absDeltaY = Math.abs(deltaY);

            if(absDeltaY > absDeltaX) {
                // return false;
            } else{
                this.$carousel.css('transform', 'translate3d('+(transformX + deltaX)+'px, 0px, 0px)');
                event.preventDefault();
            }

            // event.preventDefault();
        }

        function onTouchEnd(){
            this.$carousel.removeClass('dragging');

            elementX = parseTransformX(this.$carousel);
            const transformDelta = elementX - transformX;

            if(Math.abs(transformDelta) > this.threshold){
                if(transformDelta < 0){
                    if(this.isTablet && this.index !== this.$cards.length - 2){
                        this.next();
                    }
                    if(this.index !== this.$cards.length - 1 && !this.isTablet){
                        this.next();
                    } else{
                        this.goToIndex(this.index);
                    }
                } else {
                    if(this.index !== 0){
                        this.prev();
                    } else {
                        this.goToIndex(this.index);
                    }
                }
            } else {
                this.goToIndex(this.index);
            }
        }

        function parseTransformX(element) {
            const matrix = element.css('transform').replace(/[^0-9\-.,]/g, '').split(',');
            const x = matrix[12] || matrix[4];
            return parseInt(x);
        }
    }
}
